import classNames from 'classnames';
import * as React from 'react';

export interface DetailsButtonProps {
	className?: string;
	title: string;
	ariaLable: string;
	onClick: React.MouseEventHandler;
}

export const DetailsButton = ({ className, title, ariaLable, onClick }: DetailsButtonProps): JSX.Element => (
	<button type="button" className={classNames(className, ' btn btn-table-cell')} title={title} aria-label={ariaLable} onClick={onClick}>
		<span className="ikon ikon-se ikon--large" />
	</button>
);
